import { useMutate } from "../../../core/hooks/useMutate";

interface AudioTrimValues {
    startTime: number; // milliseconds
    endTime: number; // milliseconds
}

export function useSaveAudioTrim(
    ceremonyId: number,
    musicId: number,
    onSuccess?: (data) => void
) {
    const mutate = useMutate<AudioTrimValues>(
        `ceremonies/${ceremonyId}/music/${musicId}/trim`,
        "POST",
        {
            onSuccess: (data) => {
                if (onSuccess) onSuccess(data);
            },
        }
    );

    function handleSaveTrim(startTime: number, endTime: number) {
        mutate.mutate({ startTime, endTime });
    }

    return {
        handleSaveTrim,
        isLoading: mutate.isLoading,
    };
}
